//- key figures
if ( $(".stats").length && !$("#watch").length ) {

  function changeDivValue(div, value, currency, locale) {
    if (currency)
      $(div).text(currencyFormatI18n(value, 0, locale));
    else
      $(div).text(numberFormatI18n(value, 0, locale));
  }
  function recursiveNumberChange(div, actualNumber, number, step, currency) {
    if (actualNumber == number)
      return;
    if (number < actualNumber && step < 0 || number > actualNumber && step > 0) {
      changeDivValue(div, number, currency, wpLocale);
      return;
    }
    changeDivValue(div, actualNumber - step, currency, wpLocale)
    setTimeout(function(){
      recursiveNumberChange(div, actualNumber - step, number, step, currency)
    }, 30);
  }
  function numberTransition(div, number, currency) {
    var actualNumber = parseInt($(div).text().replace(/\D/g,''));
    var step = (actualNumber - number) / 20;
    if (step > 0 && step < 1)
      step = 1;
    else if (step < 0 && step > -1)
      step = -1;
    recursiveNumberChange(div, actualNumber, number, step, currency);
  }
  function updateKeyFigures(country) {
      if (country == 'all') { // KEY-1
        numberTransition("#lent-amount", total_lent_amount, true);
        numberTransition("#reimbursements", total_reimbursement, true);
        numberTransition("#interests", total_interests, true);
        numberTransition("#projects-received", total_projects_received, false);
        numberTransition("#projects-funded", total_projects_funded, false);
      }
      else if (country == 'fr') { // KEY-2
        numberTransition("#lent-amount", fr_lent_amount, true);
        numberTransition("#reimbursements", fr_reimbursement, true);
        numberTransition("#interests", fr_interests, true);
        numberTransition("#projects-received", fr_projects_received, false);//-siren
        numberTransition("#projects-funded", fr_projects_funded, false);
      }
      else if (country == 'es') { // KEY-3
        numberTransition("#lent-amount", es_lent_amount, true);
        numberTransition("#reimbursements", es_reimbursement, true);
        numberTransition("#interests", es_interests, true);
        numberTransition("#projects-received", es_projects_received, false);//-nif
        numberTransition("#projects-funded", es_projects_funded, false);
      }
      else if (country == 'it') { // KEY-4
        numberTransition("#lent-amount", it_lent_amount, true);
        numberTransition("#reimbursements", it_reimbursement, true);
        numberTransition("#interests", it_interests, true);
        numberTransition("#projects-received", it_projects_received, false);//-cfiscale
        numberTransition("#projects-funded", it_projects_funded, false);
      }
      else if (country == 'nl') { // KEY-5
        numberTransition("#lent-amount", nl_lent_amount, true);
        numberTransition("#reimbursements", nl_reimbursement, true);
        numberTransition("#interests", nl_interests, true);
        numberTransition("#projects-received", nl_projects_received, false);//-kvk
        numberTransition("#projects-funded", nl_projects_funded, false);
      }
      else if (country == 'de') { // KEY-5
        numberTransition("#lent-amount", de_lent_amount, true);
        numberTransition("#reimbursements", de_reimbursement, true);
        numberTransition("#interests", de_interests, true);
        numberTransition("#projects-received", de_projects_received, false); //-crefo
        numberTransition("#projects-funded", de_projects_funded, false);
      }
  }

}


